import tokenBalanceFormatter from '../../../../util/token-balance-formatter'
import useTotalSupply from '../../hooks/useTotalSupply'

export function TokenTotalSupply({ tokenId, decimals = 0 }: { tokenId: string; decimals: number }) {
  const { totalSupply, loading } = useTotalSupply(tokenId)
  if (loading) {
    return <span>Loading...</span>
  }
  return <span>{tokenBalanceFormatter(totalSupply, decimals)}</span>
}
